import { render, staticRenderFns } from "./InformationSpaceItem.vue?vue&type=template&id=05cd0b14&scoped=true"
import script from "./InformationSpaceItem.vue?vue&type=script&lang=js"
export * from "./InformationSpaceItem.vue?vue&type=script&lang=js"
import style0 from "./InformationSpaceItem.vue?vue&type=style&index=0&id=05cd0b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd0b14",
  null
  
)

export default component.exports